/**
 * ActionTypes enum.
 * @readonly
 * @enum {number}
 */
class ActionTypes {
  static CREATE = 0;
  static DELETE = 1;
  static CHANGE = 2;
  static MOVE = 3;
  static DUPLICATE = 4;
  static UNPUBLISH = 5;
  static CHECK_REPORT = 6;
  static DUPLICATE_EPUB = 7;
  static DUPLICATE_BV = 8;  
}

/**
 * PermissionTypes enum.
 * @readonly
 * @enum {string}
 */
class PermissionTypes {
  static OWNER = 'OWNER';
  static CONTRIBUTOR = 'CONTRIBUTOR';
  static REVIEWER = 'REVIEWER';
}

/**
 * AlfrescoSyncTypes enum.
 * @readonly
 * @enum {string}
 */
class AlfrescoSyncTypes {
  static PUSH = 'PUSH';
  static PULL = 'PULL';
}

/**
 * User Roles enum
 * @readonly
 * @enum {string}
 */
class UserRoles {
  static AERO_INSTRUCTOR = 'AERO_INSTRUCTOR';
  static DEVELOPER = 'DEVELOPER';
  static ADMIN = 'ADMIN';
  static STUDENT= 'STUDENT';
  static STUDENT_GUEST= 'STUDENT_GUEST';
  static SUPPORT= 'SUPPORT';
}


/**
 * File Types used for use cases like Ingestion
 * @readonly
 * @enum {string}
 */
class  FileTypes {
  static EPUB = 'EPUB';
  static DOCX = 'DOCX';
  static AMBROSIA = 'AMBROSIA';
}


/**
 * File Mime Types used for use cases like Ingestion
 * @readonly
 * @enum {string}
 */
class  FileMimeTypes {
  static AMBROSIA = ['application/json'];
  static EPUB = ['application/epub+zip'];
  static DOCX = ['application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
}



export {
  ActionTypes,
  PermissionTypes,
  AlfrescoSyncTypes,
  UserRoles,
  FileTypes,
  FileMimeTypes,
};
